import type { ComponentProps } from 'react'

import { useFieldDescribedBy } from '@/components/sui/field'
import { Input as UiInput } from '@/components/ui/input'

export function Input({
  'aria-describedby': ariaDescribedBy,
  ...props
}: ComponentProps<typeof UiInput>) {
  const describedBy = useFieldDescribedBy(ariaDescribedBy)
  return <UiInput aria-describedby={describedBy} {...props} />
}
